<template>
  <v-container id="org-details">
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        class=""
      >
        <h2>Vertragsdaten</h2>
        <v-row>
          <v-col
            cols="12"
          >
            <h3>{{ organization ? organization.name : '' }}</h3>

            <div class="mt-4">
              <v-row class="mt-2">
                <v-col cols="12" md="4">
                  <v-expansion-panels flat hover>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="pa-0">
                        Allgemeine Optionen
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div v-if="isSuperuser" class="setting-container">
                          <v-switch
                            disabled
                            color="primary"
                            label="Liturgischer Kalender"
                            v-model="calenderFlag"
                          >
                            <template #label>
                              <v-btn
                                disabled
                                icon
                                :color="inheritanceColor('no_inherit_calendar', 'no_inherit_calendar')"
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              Liturgischer Kalender
                            </template>
                          </v-switch>
                        </div>

                        <div class="setting-container">
                          <v-switch
                            :readonly="!isSuperuser"
                            :disabled="!isSuperuser"
                            color="primary"
                            label="Kollektenvererbung"
                            v-model="collectionFlag"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('no_inherit_collections')"
                                disabled
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              Kollektenvererbung
                            </template>
                          </v-switch>
                        </div>

                        <div
                          class="setting-container d-flex align-center"
                        >
                          <v-switch
                            color="primary"
                            :label="settings.find(s => s.id === 'allow_collection_split').label"
                            v-model="settings.find(s => s.id === 'allow_collection_split').value"
                            @change="changeLocalSetting(settings.find(s => s.id === 'allow_collection_split'))"
                            :disabled="!isSuperuser"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('allow_collection_split')"
                                @click.stop="changeInheritSetting('allow_collection_split')"
                                :disabled="!isSuperuser"
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              {{ settings.find(s => s.id === 'allow_collection_split').label }} <span class="ml-1 text-caption text-secondary" :class="settings.find(s => s.id === 'allow_collection_split').isDifferentFromInheritedValue ? 'text-decoration-line-through' : ''">{{ settings.find(s => s.id === 'allow_collection_split').inherited  ? '(Einstellung vererbt)' : '' }}</span>
                            </template>
                          </v-switch>
                          <help-tooltip
                            :text="FEATURE_HELP_TEXTS.allow_collection_split"
                          />
                        </div>

                        <div
                          class="setting-container"
                          v-for="feature in [FEATURE_RESOURCE_TYPE_MAP.ADVANCED_NOTIFICATION_FEATURE, FEATURE_RESOURCE_TYPE_MAP.DISBURSEMENT_ORDER_FEATURE, FEATURE_RESOURCE_TYPE_MAP.TAGGED_COLLECTION_PLAN_FEATURE]"
                          :key="feature"
                        >
                          <feature-switch
                            v-bind="featureSwitchProps(feature)"
                            v-on="featureSwitchListeners"
                          />
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>

                <v-col cols="12" md="4">
                  <v-expansion-panels flat hover>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="pa-0">
                        Features
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div
                          class="setting-container"
                          v-if="isDeviceInOrganizationHierarchy(organization, 'bart', 'enableWS')"
                        >
                          <v-switch
                            @click.native.stop
                            v-model="isSpendeAppEnabled"
                            color="primary"
                            label="spende.app"
                            :disabled="!isSuperuser"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('enableWS', 'override')"
                                @click.stop="changeInheritSetting('enableWS', 'override')"
                                :disabled="!isSuperuser"
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              spende.app
                            </template>
                          </v-switch>
                        </div>
                        <div
                          class="setting-container"
                          v-if="isDeviceInOrganizationHierarchy(organization, 'john', 'enableWA')"
                        >
                          <v-switch
                            v-model="isKollekteAppEnabled"
                            color="primary"
                            label="kollekte.app"
                            :disabled="!isSuperuser"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('enableWA', 'override')"
                                @click.stop="changeInheritSetting('enableWA', 'override')"
                                :disabled="!isSuperuser"
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              kollekte.app
                            </template>
                          </v-switch>
                        </div>
                        <div
                          class="setting-container"
                          v-for="[feature, label] in [[FEATURE_RESOURCE_TYPE_MAP.VERANSTALTUNG_APP_FEATURE, 'veranstaltung.app'], [FEATURE_RESOURCE_TYPE_MAP.KIRCHGELD_DIGITAL_FEATURE, 'kirchgeld.digital']]"
                          :key="feature"
                        >
                          <feature-switch
                            v-bind="featureSwitchProps(feature, label)"
                            v-on="featureSwitchListeners"
                          />
                        </div>
                        <div
                          class="setting-container d-flex align-center"
                        >
                          <v-switch
                            v-if="!(isDeviceInOrganizationHierarchy(organization, 'cash')) === false"
                            color="primary"
                            :label="settings.find(s => s.id === 'allow_cash_payments').label"
                            v-model="settings.find(s => s.id === 'allow_cash_payments').value"
                            @change="changeLocalSetting(settings.find(s => s.id === 'allow_cash_payments'))"
                            :disabled="!isSuperuser"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('allow_cash_payments')"
                                @click.stop="changeInheritSetting('allow_cash_payments')"
                                :disabled="!isSuperuser"
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              {{ settings.find(s => s.id === 'allow_cash_payments').label }} <span class="ml-1 text-caption text-secondary" :class="settings.find(s => s.id === 'allow_cash_payments').isDifferentFromInheritedValue ? 'text-decoration-line-through' : ''">{{ settings.find(s => s.id === 'allow_cash_payments').inherited  ? '(Einstellung vererbt)' : '' }}</span>
                            </template>
                          </v-switch>
                          <help-tooltip
                            v-if="!(isDeviceInOrganizationHierarchy(organization, 'cash')) === false"
                            :text="FEATURE_HELP_TEXTS.allow_cash_payments"
                          />
                        </div>
                        <div class="setting-container">
                          <feature-switch
                            v-bind="featureSwitchProps(FEATURE_RESOURCE_TYPE_MAP.DONATION_METER_FEATURE)"
                            v-on="featureSwitchListeners"
                          />
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>

                <v-col cols="12" md="4">
                  <v-expansion-panels flat hover>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="pa-0">
                        Optionen Web-Apps
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div
                          class="setting-container d-flex align-center"
                        >
                          <v-switch
                            color="primary"
                            :label="settings.find(s => s.id === 'allow_recurring_payments').label"
                            v-model="settings.find(s => s.id === 'allow_recurring_payments').value"
                            @change="changeLocalSetting(settings.find(s => s.id === 'allow_recurring_payments'))"
                            :disabled="!isSuperuser"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('allow_recurring_payments')"
                                @click.stop="changeInheritSetting('allow_recurring_payments')"
                                :disabled="!isSuperuser"
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              {{ settings.find(s => s.id === 'allow_recurring_payments').label }} <span class="ml-1 text-caption text-secondary" :class="settings.find(s => s.id === 'allow_recurring_payments').isDifferentFromInheritedValue ? 'text-decoration-line-through' : ''">{{ settings.find(s => s.id === 'allow_recurring_payments').inherited  ? '(Einstellung vererbt)' : '' }}</span>
                            </template>
                          </v-switch>
                          <help-tooltip
                            :text="FEATURE_HELP_TEXTS.allow_recurring_payments"
                          />
                        </div>
                        <div
                          class="setting-container"
                        >
                          <v-switch
                            color="primary"
                            :label="settings.find(s => s.id === 'allow_email_contact').label"
                            v-model="settings.find(s => s.id === 'allow_email_contact').value"
                            @change="changeLocalSetting(settings.find(s => s.id === 'allow_email_contact'))"
                            :disabled="!isSuperuser"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('allow_email_contact')"
                                @click.stop="changeInheritSetting('allow_email_contact')"
                                :disabled="!isSuperuser"
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              {{ settings.find(s => s.id === 'allow_email_contact').label }} <span class="ml-1 text-caption text-secondary" :class="settings.find(s => s.id === 'allow_email_contact').isDifferentFromInheritedValue ? 'text-decoration-line-through' : ''">{{ settings.find(s => s.id === 'allow_email_contact').inherited  ? '(Einstellung vererbt)' : '' }}</span>
                            </template>
                          </v-switch>
                        </div>
                        <div class="setting-container d-flex align-center">
                          <v-switch
                            color="primary"
                            label="Anonyme Spenden verbieten"
                            v-model="arePersonalDataRequiredForDonation"
                            @change="changeLocalSetting({id: 'require_pdata', value: arePersonalDataRequiredForDonation})"
                            :disabled="!isSuperuser"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('require_pdata')"
                                @click.stop="changeInheritSetting('require_pdata')"
                                :disabled="!isSuperuser"
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              Anonyme Spenden verbieten
                            </template>
                          </v-switch>
                          <help-tooltip
                            :text="FEATURE_HELP_TEXTS.require_pdata"
                          />
                        </div>
                        <!-- Superusers without a configuration only get the button to create one -->
                        <template v-if="hasDonationReceiptConfiguration || !isSuperuser">
                        <div class="setting-container">
                          <v-switch
                            disabled
                            class="disable-events"
                            color="primary"
                            label="Spendenbescheinigung"
                            v-model="isDonationReceiptEnabled"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('request_donation_receipt')"
                                disabled
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              Spendenbescheinigung
                            </template>
                          </v-switch>
                          <div v-if="donationReceiptConfigurations.length">
                            <div
                              v-for="(donationReceiptConfiguration, index) in donationReceiptConfigurations"
                              :key="index"
                              class="text-caption d-flex align-start"
                            >
                              <div class="flex-grow-1">
                                <div>
                                  Mindestbetrag: {{ donationReceiptConfiguration.min_amount_donation | currency(organization.currency || '€', false, false) }}
                                </div>
                                <div>
                                  Gültigkeitszeitraum:
                                  <template v-if="donationReceiptConfiguration.valid_from">
                                    ab {{ momentize(donationReceiptConfiguration.valid_from) }}
                                  </template>
                                  <template v-if="donationReceiptConfiguration.valid_notafter">
                                    bis {{ formatLastValidDay(donationReceiptConfiguration.valid_notafter) }}
                                  </template>
                                  <template v-if="!donationReceiptConfiguration.valid_from && !donationReceiptConfiguration.valid_notafter">
                                    Keine Einschränkungen / Angaben
                                  </template>
                                </div>
                              </div>
                              <v-btn
                                v-if="isSuperuser"
                                icon
                                x-small
                                class="ml-1"
                                @click="openDonationReceiptDialog(donationReceiptConfiguration)"
                              >
                                <v-icon x-small>{{ mdiPencil }}</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </div>
                        <div class="setting-container">
                          <v-switch
                            disabled
                            color="primary"
                            label="Spendenbescheinigung für Kollekten"
                            v-model="isDonationReceiptForCollectionEnabled"
                          >
                            <template #label>
                              <v-btn
                                icon
                                :color="inheritanceColor('donation_receipt_for_collection')"
                                disabled
                              >
                                <v-icon>{{ mdiTransferDown }}</v-icon>
                              </v-btn>
                              Spendenbescheinigung für Kollekten
                            </template>
                          </v-switch>
                          <div v-if="donationReceiptForCollectionConfigurations.length">
                            <div
                              v-for="(donationReceiptConfiguration, index) in donationReceiptForCollectionConfigurations"
                              :key="index"
                              class="text-caption d-flex align-start"
                            >
                              <div class="flex-grow-1">
                                <div>
                                  Mindestbetrag: {{ donationReceiptConfiguration.min_amount_collection | currency(organization.currency || '€', false, false) }}
                                </div>
                                <div>
                                  Gültigkeitszeitraum:
                                  <template v-if="donationReceiptConfiguration.valid_from">
                                    ab {{ momentize(donationReceiptConfiguration.valid_from) }}
                                  </template>
                                  <template v-if="donationReceiptConfiguration.valid_notafter">
                                    bis {{ formatLastValidDay(donationReceiptConfiguration.valid_notafter) }}
                                  </template>
                                  <template v-if="!donationReceiptConfiguration.valid_from && !donationReceiptConfiguration.valid_notafter">
                                    Keine Einschränkungen / Angaben
                                  </template>
                                </div>
                              </div>
                              <v-btn
                                v-if="isSuperuser"
                                icon
                                x-small
                                class="ml-1"
                                @click="openDonationReceiptDialog(donationReceiptConfiguration)"
                              >
                                <v-icon x-small>{{ mdiPencil }}</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </div>
                        </template>
                        <!-- Further configurations are separate validity windows; the dialog rejects overlaps -->
                        <div
                          v-if="isSuperuser"
                          class="setting-container mt-2"
                        >
                          <v-btn
                            small
                            outlined
                            color="primary"
                            @click="openDonationReceiptDialog(null)"
                          >
                            <v-icon
                              left
                              small
                            >
                              {{ mdiPlus }}
                            </v-icon>
                            Spendenbescheinigungskonfiguration
                          </v-btn>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </div>

            <v-card outlined class="mt-6">
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editShortName"
                      label="Kurzname für Lastschriften"
                      dense
                      outlined
                      :readonly="!canEditShortNameAndIdentifiers"
                      :disabled="!canEditShortNameAndIdentifiers"
                      :rules="[v => (v || '').length <= 13 || 'Max. 13 Zeichen erlaubt']"
                      counter="13"
                      @input="shortNameChanged = true"
                      @keydown.enter="saveShortName"
                      :append-icon="shortNameChanged ? mdiCheck : null"
                      @click:append="saveShortName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="accountNumber"
                      label="Kundennummer"
                      outlined
                      dense
                      :readonly="!isSuperuser"
                      :disabled="!isSuperuser"
                      :rules="accountNumberRules"
                      counter="5"
                      @input="hasAccountNumberChanged = true"
                      @keydown.enter="updateAccountNumber"
                      :append-icon="hasAccountNumberChanged ? mdiCheck : null"
                      @click:append="updateAccountNumber"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="isSuperuser" cols="12">
                    <v-text-field
                      v-model="saveFileUrl"
                      label="URL zum Dateiaustausch"
                      outlined
                      dense
                      @input="hasSaveFileUrlChanged = true"
                      @keydown.enter="updateSaveFileUrl"
                      :append-icon="hasSaveFileUrlChanged ? mdiCheck : null"
                      @click:append="updateSaveFileUrl"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-for="key in visibleIdentifierKeys"
                    :key="key"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="editIdentifiers[key]"
                      :label="enumsByName && enumsByName.OrganizationIdentifierType && enumsByName.OrganizationIdentifierType[key] || key"
                      dense
                      outlined
                      :readonly="!canEditShortNameAndIdentifiers"
                      :disabled="!canEditShortNameAndIdentifiers"
                      :rules="key === 'kro' ? kroRules : []"
                      :counter="key === 'kro' ? 10 : null"
                      @input="$set(identifiersChanged, key, true)"
                      @keydown.enter="saveIdentifiers"
                      :append-icon="identifiersChanged[key] ? mdiCheck : null"
                      @click:append="saveIdentifiers"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="canEditShortNameAndIdentifiers && availableIdentifierKeysToPick.length > 0"
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="newIdentifierKey"
                      :items="availableIdentifierKeysToPick.map(key => ({
                        text: enumsByName && enumsByName.OrganizationIdentifierType && enumsByName.OrganizationIdentifierType[key] || key,
                        value: key
                      }))"
                      label="Kennung hinzufügen"
                      dense
                      outlined
                      @change="key => {
                        manuallyAddedIdentifierKeys.push(key)
                        if (editIdentifiers[key] === undefined) {
                          $set(editIdentifiers, key, '')
                        }
                        $nextTick(() => { newIdentifierKey = null })
                      }"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card outlined class="mt-6">
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-switch
                      v-model="reconciliationSettings.is_enabled"
                      label="Kollektenübertrag"
                      :disabled="!canEditShortNameAndIdentifiers || reconciliationSettings.is_enabled"
                      @change="onReconciliationEnabledChange"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="reconciliationSettings.real_account"
                      label="Echtes Bankkonto"
                      dense
                      outlined
                      :readonly="!canEditShortNameAndIdentifiers"
                      :disabled="!canEditShortNameAndIdentifiers"
                      :rules="ibanRules"
                      @input="hasReconciliationSettingsChanged = true"
                      @keydown.enter="saveReconciliationSettings"
                      :append-icon="hasReconciliationSettingsChanged ? mdiCheck : null"
                      @click:append="saveReconciliationSettings"
                      @blur="reconciliationSettings.real_account = electronicFormatIBAN(reconciliationSettings.real_account)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="reconciliationSettings.virtual_account"
                      label="Virtuelles Bankkonto (automatisch berechnet)"
                      dense
                      outlined
                      readonly
                      disabled
                      class="disable-events"
                      :error="hasVirtualAccountMismatch"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="hasVirtualAccountMismatch" cols="12">
                    <v-alert
                      type="warning"
                      :icon="mdiAlertCircle"
                      dense
                      outlined
                    >
                      Das virtuelle Bankkonto stimmt nicht mit der KRO überein (erwartet: {{ expectedVirtualAccount }}).
                      <v-btn
                        v-if="canEditShortNameAndIdentifiers"
                        small
                        text
                        color="warning"
                        class="ml-2"
                        @click="fixVirtualAccount"
                      >
                        <v-icon left small>{{ mdiAutorenew }}</v-icon>
                        Korrigieren
                      </v-btn>
                    </v-alert>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
          >
            <div v-if="isSuperuser || hasReadingPermissions">
              <h4>Adressen</h4>
              <organization-component
                :organization="organization"
              ></organization-component>
            </div>
          </v-col>

          <v-col
            v-if="availableTags.length || canEditShortNameAndIdentifiers"
            cols="12"
            lg="6"
          >
            <v-card outlined class="pa-4">
              <div class="mb-4">
                Hier können Sie der Organisation eine Sektion hinzufügen. Diese ermöglichen die Einschränkung der Vererbung von Sammlungen auf Teilgruppen.
              </div>
              <v-autocomplete
                v-model="organizationTags"
                :items="availableTags"
                :label="$t('organization.features.TaggedCollectionPlanFeature')"
                multiple
                chips
                small-chips
                deletable-chips
                :readonly="!canEditShortNameAndIdentifiers"
                :disabled="!canEditShortNameAndIdentifiers"
                :prepend-icon="mdiTagMultiple"
                hide-selected
              >
                <template #append-outer>
                  <help-tooltip :text="FEATURE_HELP_TEXTS.TaggedCollectionPlanFeature" />
                </template>
              </v-autocomplete>
            </v-card>
          </v-col>

          <v-col
            v-if="availableContracts.length > 0"
            cols="12"
          >
            <h3>Eigene Verträge</h3>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >

          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="contract in availableContracts"
            :key="contract.id"
            cols="12"
            md="6"
          >
            <organization-contract-billing-card
              :contract="contract"
              :organization="organization"
              @update="loadBillingPlanAssociations"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  <donation-receipt-config-dialog
    :is-open="donationReceiptDialogOpen"
    :organization="organization"
    :existing-config="donationReceiptDialogConfig"
    @close="donationReceiptDialogOpen = false"
    @saved="reloadOrganization"
  />
  <feature-edit-dialog
    :is-open="featureEditDialog.open"
    :feature="featureEditDialog.feature"
    :label="featureEditDialog.label"
    :type="featureEditDialog.type"
    :help="featureEditDialog.help"
    :reactivate="featureEditDialog.reactivate"
    :organization="organization"
    @close="featureEditDialog.open = false"
    @saved="reloadOrganization"
  />
  <feature-end-dialog
    :is-open="featureEndDialog.open"
    :feature="featureEndDialog.feature"
    :label="featureEndDialog.label"
    @close="featureEndDialog.open = false"
    @ended="reloadOrganization"
  />
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import {
  FEATURE_TO_SETTINGS_KEY_MAP,
  FEATURE_RESOURCE_TYPE_MAP,
  FEATURE_TYPE_BY_RESOURCE_TYPE,
  CREATABLE_FEATURE_RESOURCE_TYPES,
  FEATURE_HELP_TEXTS,
  ALLOW_CASH_PAYMENTS
} from '@/lib/settings-tools'
import moment from "moment"
import { READ_ORG_DATA, WRITE_ORG_DATA, WRITE_ACCOUNTS } from "@/lib/permission-tools"
import {
  mdiPlus,
  mdiTransferDown,
  mdiCheck,
  mdiInformationOutline,
  mdiPencil,
  mdiTagMultiple,
  mdiAlertCircle,
  mdiAutorenew
} from "@mdi/js"
import { electronicFormatIBAN as formatIBAN, isValidIBAN } from "ibantools"
import { mapOrder } from "@/lib/data-order"
import { calculateVirtualAccount } from "@/lib/reconciliation-tools"
import OrganizationComponent from "@/components/OrganizationComponent"
import {
  FETCH_BILLING_PLAN_CONTRACT_ASSOCIATION,
  FETCH_BILLING_PLANS, FETCH_CONTRACTS,
  FETCH_DIRECT_PAYMENT_PAIN_FILES,
  FETCH_GLOBAL_DEVICES,
  FETCH_STATIC_CONFIGURATION,
  PATCH_ORGANIZATION,
  UPDATE_INHERIT_ORGANIZATION_SETTING,
  UPDATE_LOCAL_ORGANIZATION_SETTING
} from '@/store/action-types'
import { getLatestVersion, isCurrentlyValid, lastValidDay } from "@/lib/sort-utils"
import { SET_SNACKBAR_MESSAGE } from "@/modules/common/store/mutation-types"
import OrganizationContractBillingCard from "@/components/OrganizationContractBillingCard.vue"
import DonationReceiptConfigDialog from "@/components/management/DonationReceiptConfigDialog.vue"
import FeatureSwitch from "@/components/management/FeatureSwitch.vue"
import FeatureEndDialog from "@/components/management/FeatureEndDialog.vue"
import FeatureEditDialog from "@/components/management/FeatureEditDialog.vue"
import HelpTooltip from "@/components/UI/HelpTooltip.vue"
import { formatApiError } from "@/lib/api-errors"
import { SET_ORGANIZATION } from "@/store/mutation-types"

export default {
  name: 'org-details',
  components: {
    OrganizationContractBillingCard,
    OrganizationComponent,
    DonationReceiptConfigDialog,
    FeatureSwitch,
    FeatureEndDialog,
    FeatureEditDialog,
    HelpTooltip
  },
  data () {
    return {
      FEATURE_RESOURCE_TYPE_MAP,
      addressesOrder: ['primary', 'physical', 'billing', 'other'],
      mdiPlus,
      mdiTransferDown,
      mdiCheck,
      mdiInformationOutline,
      mdiPencil,
      mdiTagMultiple,
      mdiAlertCircle,
      mdiAutorenew,
      donationReceiptDialogOpen: false,
      donationReceiptDialogConfig: null,
      featureEndDialog: { open: false, feature: null, label: '' },
      featureEditDialog: { open: false, feature: null, label: '', type: null, help: null, reactivate: false },
      FEATURE_HELP_TEXTS,
      arePersonalDataRequiredForDonation: false,
      accountNumber: '',
      hasAccountNumberChanged: false,
      saveFileUrl: '',
      hasSaveFileUrlChanged: false,
      billingPlanContractAssociations: {},
      shortNameChanged: false,
      identifiersChanged: {},
      manuallyAddedIdentifierKeys: [],
      newIdentifierKey: null,
      editShortName: '',
      editIdentifiers: {
        kro: ''
      },
      reconciliationSettings: {
        is_enabled: false,
        real_account: '',
        virtual_account: '',
        reporting_mode: ''
      },
      hasReconciliationSettingsChanged: false,
      ibanRules: [
        value => !value || isValidIBAN(formatIBAN(value)) || 'Bitte geben Sie eine gültige IBAN ein.',
        value => (!!this.reconciliationSettings.real_account || !!this.editIdentifiers.kro || !this.reconciliationSettings.is_enabled) || 'Entweder IBAN oder KRO muss bei aktivem Kollektenübertrag ausgefüllt sein.'
      ],
      accountNumberRules: [
        value => !value || value.length === 5 || 'Kundennummer muss genau 5 Zeichen lang sein.'
      ],
      kroRules: [
        value => !value || value.length === 10 || 'KRO muss genau 10 Zeichen lang sein.',
        value => (!!this.reconciliationSettings.real_account || !!this.editIdentifiers.kro || !this.reconciliationSettings.is_enabled) || 'Entweder IBAN oder KRO muss bei aktivem Kollektenübertrag ausgefüllt sein.'
      ]
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('user', ['user']),
    ...mapState('staticConfiguration', ['enumsByName']),
    ...mapGetters('organization', {
      organization: 'currentOrganization',
    }),
    ...mapGetters('organization', [
      'allOrganizations',
      'organizationSettingsByUrl',
      'organizationRelevantDevicesRawByUrl',
      'parents'
    ]),
    ...mapGetters('settings', {
      effectiveSettings: 'effectiveSettingsForUrl'
    }),
    ...mapGetters('user', ['isSuperuser', 'hasPermission']),
    inheritanceColor () {
      return (settingId, subscope = 'features') => this.shouldPassDownSetting(settingId, subscope) ? 'primary' : ''
    },
    ...mapGetters('contracts', ['contractsByOrganizationAndDevices', 'contractsByOrganization']),
    ...mapGetters('billing', ['billingPlanByUrl']),
    addresses () {
      if (!this.organization || !this.organization.addresses) {
        return []
      }
      return mapOrder(this.organization.addresses, this.addressesOrder, 'type')
    },
    additionalFields () {
      // eslint-disable-next-line camelcase
      return (this.$store.getters['organization/organizationSettingsByUrl'][this.orgUrl] ?? {})?.accounting?.extra_fields ?? null
    },
    orgUrl () {
      return this.organization.url ?? null
    },
    flags () {
      return this.organization.flags
    },
    calenderFlag () {
      return !this.flags.includes('no_inherit_calendar')
    },
    collectionFlag: {
      get () {
        return !this.flags.includes('no_inherit_collections')
      },
      async set (value) {
        const updatedFlags = value ? this.flags.filter(flag => flag !== 'no_inherit_collections') : [...this.flags, 'no_inherit_collections']

        await this.$store.dispatch('organization/' + PATCH_ORGANIZATION, {
          url: this.organization.url,
          data: { flags: updatedFlags }
        })
        if (!value) {
          await this.$store.getters.restApi.post(this.organization.url + 'recalculate_cplan/')
        }
        this.$store.commit(SET_SNACKBAR_MESSAGE, {
          message: 'Organisation wurde erfolgreich gespeichert.',
          color: 'success'
        })
      }
    },
    features () {
      return this.effectiveSettings(this.orgUrl)?.features ?? {}
    },
    isSuperuser () {
      // eslint-disable-next-line camelcase
      return this.user?.is_superuser || false
    },
    inheritedSettings () {
      const inheritedSettings = this.$store.getters["settings/settingsForUrl"](this.organization.url, false)
      return inheritedSettings.features ?? {}
    },
    settings () {
      const settingsArray = []
      Object.keys(FEATURE_TO_SETTINGS_KEY_MAP).forEach(key => {
        if (key === ALLOW_CASH_PAYMENTS && !this.isDeviceInOrganizationHierarchy(this.organization, 'cash')) {
          return
        }

        const settingKey = FEATURE_TO_SETTINGS_KEY_MAP[key]
        const settingValue = this.features[key] || false
        const isInherited = Object.keys(this.inheritedSettings).includes(key)
        const inheritedValue = this.inheritedSettings[key]
        settingsArray.push({
          id: key,
          label: settingKey,
          value: settingValue,
          inherited: isInherited,
          isDifferentFromInheritedValue: settingValue !== inheritedValue || false,
          inheritedValue
        })
      })
      return settingsArray
    },
    featureSwitchListeners () {
      return {
        edit: this.openFeatureEditDialog,
        'toggle-inherit': this.toggleFeatureInherit,
        end: this.openFeatureEndDialog
      }
    },
    hasDonationReceiptConfiguration () {
      return !!this.organization.donation_receipt_configurations?.length
    },
    donationReceiptConfigurations () {
      const donationReceiptConfigurations = this.organization.donation_receipt_configurations

      if (!donationReceiptConfigurations?.length) {
        return []
      }

      return donationReceiptConfigurations.filter(config => !!config.min_amount_donation)
    },
    donationReceiptForCollectionConfigurations () {
      const donationReceiptConfigurations = this.organization.donation_receipt_configurations

      if (!donationReceiptConfigurations?.length) {
        return []
      }

      return donationReceiptConfigurations.filter(config => !!config.min_amount_collection)
    },
    isDonationReceiptEnabled () {
      if (!this.donationReceiptConfigurations.length) {
        return false
      }

      for (const donationReceiptConfiguration of this.donationReceiptConfigurations) {
        // eslint-disable-next-line camelcase
        if (donationReceiptConfiguration?.min_amount_donation) {
          return true
        }
      }

      // eslint-disable-next-line camelcase
      return this.features?.request_donation_receipt || false
    },
    isDonationReceiptForCollectionEnabled () {
      if (!this.donationReceiptForCollectionConfigurations?.length) {
        return false
      }

      for (const donationReceiptConfiguration of this.donationReceiptForCollectionConfigurations) {
        // eslint-disable-next-line camelcase
        if (donationReceiptConfiguration?.min_amount_collection) {
          return true
        }
      }

      // eslint-disable-next-line camelcase
      return this.features?.donation_receipt_for_collection || false
    },
    hasReadingPermissions () {
      return this.hasPermission(this.organization.url, READ_ORG_DATA)
    },
    hasEditingPermissions () {
      return this.hasPermission(this.organization.url, WRITE_ORG_DATA)
    },
    visibleIdentifierKeys () {
      const existingKeys = Object.keys(this.organization.identifiers || {})
      if (!this.canEditShortNameAndIdentifiers) {
        return existingKeys.filter(key => !!this.organization.identifiers[key])
      }
      return [...new Set([...existingKeys.filter(key => !!this.organization.identifiers[key]), ...this.manuallyAddedIdentifierKeys])]
    },
    availableIdentifierKeysToPick () {
      const allPossibleKeys = Object.keys(this.enumsByName?.OrganizationIdentifierType || {})
      const currentlyVisible = this.visibleIdentifierKeys
      return allPossibleKeys.filter(key => !currentlyVisible.includes(key))
    },
    canEditShortNameAndIdentifiers () {
      return this.isSuperuser || this.hasPermission(this.organization.url, WRITE_ACCOUNTS)
    },
    expectedVirtualAccount () {
      return calculateVirtualAccount(this.editIdentifiers?.kro)
    },
    hasVirtualAccountMismatch () {
      return !!this.expectedVirtualAccount && this.expectedVirtualAccount !== this.reconciliationSettings.virtual_account
    },
    availableTags () {
      const tags = new Set()
      const organizationBranchUrls = [this.organization.url, ...(this.parents[this.organization.url] ?? [])]
      organizationBranchUrls.forEach(url => {
        const org = this.allOrganizations[url]
        if (!org) return

        const feature = (org.features ?? []).find(f => f.resourcetype === 'TaggedCollectionPlanFeature' && isCurrentlyValid(f))
        if (feature?.tags) {
          feature.tags.forEach(tag => tags.add(tag))
        }
        if (org.tags) {
          org.tags.forEach(tag => tags.add(tag))
        }
      })
      return Array.from(tags).sort()
    },
    organizationTags: {
      get () {
        return Array.from(this.organization.tags ?? [])
      },
      async set (value) {
        await this.$store.dispatch('organization/' + PATCH_ORGANIZATION, {
          url: this.organization.url,
          data: {
            tags: value.join(' ')
          }
        })
        this.$store.commit(SET_SNACKBAR_MESSAGE, {
          message: 'Tags erfolgreich aktualisiert',
          color: 'success'
        })
      }
    },
    effectiveOrganizationSettings () {
      return this.$store.getters["settings/effectiveSettingsForUrl"](this.organization.url)
    },

    isSpendeAppEnabled: {
      get () {
        if (this.organization.device_types.includes('bart')) {
          return true
        }

        if (this.effectiveOrganizationSettings?.override?.enableWS !== null) {
          return this.effectiveOrganizationSettings?.override?.enableWS || false
        }

        if (this.isDeviceInOrganizationHierarchy(this.organization, 'bart', 'enableWS')) {
          return true
        }

        return false
      },
      async set (value) {
        const data = {
          settings_local: {
            override: {
              enableWS: value
            }
          }
        }
        await this.$store.dispatch('organization/' + PATCH_ORGANIZATION, {
          url: this.organization.url,
          data
        })
      }
    },
    isKollekteAppEnabled: {
      get () {
        if (this.organization.device_types.includes('john')) {
          return true
        }

        if (this.effectiveOrganizationSettings?.override?.enableWA !== null) {
          return this.effectiveOrganizationSettings?.override?.enableWA || false
        }

        if (this.isDeviceInOrganizationHierarchy(this.organization, 'john', 'enableWA')) {
          return true
        }

        return false
      },
      async set (value) {
        const data = {
          settings_local: {
            override: {
              enableWA: value
            }
          }
        }
        await this.$store.dispatch('organization/' + PATCH_ORGANIZATION, {
          url: this.organization.url,
          data
        })
      }
    },
    contracts () {
      return this.contractsByOrganization[this.organization.url]?.allContracts ?? []
    },
    availableContracts () {
      return this.contracts
        .filter(contract => ['op', 'ps', 'service'].includes(contract.type))
        .map(contract => {
          let billingPlans = []
          let billingPlanContractAssociations = []
          if (this.billingPlanContractAssociations[contract.id]) {
            billingPlanContractAssociations = this.billingPlanContractAssociations[contract.id]
            billingPlans = billingPlanContractAssociations.map(association => this.billingPlanByUrl[association.billing_plan])
          }
          return {
            ...contract,
            billingPlans,
            billingPlanContractAssociations
          }
        })
    },
    hasValidContract () {
      return this.contractsByOrganization[this.organization.url]?.hasValidContract ?? false
    },
    billingAddress () {
      if (!this.organization.addresses) {
        return ''
      }
      const billingAddressCandidates = this.organization.addresses.filter(address => address.type === 'billing')
      if (!billingAddressCandidates.length) {
        return ''
      }

      const billingAddress = getLatestVersion(billingAddressCandidates)

      return `${this.organization.name}, ${billingAddress.address}, ${billingAddress.postcode} ${billingAddress.locality}`
    }
  },
  created () {
  },
  methods: {
    featuresOfType (resourcetype) {
      return (this.organization.features ?? []).filter(f => f.resourcetype === resourcetype)
    },
    featureSwitchProps (resourcetype, label = null) {
      return {
        label: label ?? this.$t('organization.features.' + resourcetype),
        features: this.featuresOfType(resourcetype),
        organizationUrl: this.organization.url,
        help: FEATURE_HELP_TEXTS[resourcetype],
        type: FEATURE_TYPE_BY_RESOURCE_TYPE[resourcetype],
        creatable: CREATABLE_FEATURE_RESOURCE_TYPES.includes(resourcetype),
        canManage: this.isSuperuser
      }
    },
    async toggleFeatureInherit (feature, label) {
      try {
        await this.$store.getters.restApi.patch(`feature/${feature.id}/`, { inherit: !feature.inherit })
        this.$store.commit(SET_SNACKBAR_MESSAGE, {
          message: feature.inherit
            ? `${label} wird nicht mehr an untergeordnete Organisationen vererbt.`
            : `${label} wird an untergeordnete Organisationen vererbt.`,
          color: 'success'
        })
        await this.reloadOrganization()
      } catch (e) {
        this.$store.commit(SET_SNACKBAR_MESSAGE, { message: formatApiError(e), color: 'error' })
      }
    },
    openFeatureEditDialog (feature, label, type, help = null, reactivate = false) {
      this.featureEditDialog = { open: true, feature, label, type, help, reactivate }
    },
    openFeatureEndDialog (feature, label) {
      this.featureEndDialog = { open: true, feature, label }
    },
    openDonationReceiptDialog (config) {
      this.donationReceiptDialogConfig = config
      this.donationReceiptDialogOpen = true
    },
    async reloadOrganization () {
      const response = await this.$store.getters.restApi.get(this.organization.url)
      this.$store.commit('organization/' + SET_ORGANIZATION, { data: response.data })
    },
    changeLocalSetting (setting) {
      this.$store.dispatch('organization/' + UPDATE_LOCAL_ORGANIZATION_SETTING, {
        organization: this.organization,
        setting
      })
    },
    changeInheritSetting (settingId, subscope = 'features') {
      this.$store.dispatch('organization/' + UPDATE_INHERIT_ORGANIZATION_SETTING, {
        organization: this.organization,
        setting: {
          id: settingId,
          value: !this.shouldPassDownSetting(settingId, subscope),
        },
        subscope
      })
    },
    shouldPassDownSetting (settingId, subscope = 'features') {
      return this.organization?.settings_inherit?.[subscope]?.[settingId] ?? false
    },
    isDeviceInOrganizationHierarchy (organization, deviceType, overrideField) {
      const orgaDevices = this.organization.device_types ?? []
      if (orgaDevices.includes(deviceType)) {
        return true
      }

      for (const parentUrl of this.parents[organization.url]) {
        // eslint-disable-next-line camelcase
        const parentDevices = this.allOrganizations[parentUrl]?.device_types ?? []
        // const doesParentPassDownSetting = parentOrg?.settings_inherit?.override?.[overrideField] ?? false
        if (parentDevices.includes(deviceType)) {
          return true
        }
      }
      return false
    },
    myJoiner (arr, sep, map) {
      const retVal = []
      for (const key in arr) {
        const val = arr[key]
        if (map[val]) {
          retVal.push(map[val])
        } else {
          retVal.push(val)
        }
      }
      return retVal.join(sep)
    },
    momentize (date) {
      return moment(date, [moment.ISO_8601, 'DD.MM.YYYY']).format('DD.MM.YYYY')
    },
    formatLastValidDay (validNotafter) {
      return lastValidDay(validNotafter)?.format('DD.MM.YYYY') ?? ''
    },
    async loadBillingPlanAssociations () {
      if (!this.isSuperuser) {
        return
      }
      const requests = this.contracts
        .filter(contract => ['op', 'ps', 'service'].includes(contract.type))
        .map(contract => {
          return this.$store.dispatch('contracts/' + FETCH_BILLING_PLAN_CONTRACT_ASSOCIATION, {
            contractId: contract.id
          })
        })

      const responses = await Promise.all(requests)

      responses.forEach(assocations => {
        if (!assocations.length) {
          return
        }

        // TODO: Make this pretty as soon we have URLs in the contract payload
        const latestAssociation = getLatestVersion(assocations)
        const contractId = latestAssociation.contract.split('/').filter(Boolean).pop()

        this.$set(this.billingPlanContractAssociations, contractId, assocations)
      })
      return responses
    },
    async updateAccountNumber () {
      if (this.accountNumber && this.accountNumber.length !== 5) {
        return
      }
      await this.$store.dispatch('organization/' + PATCH_ORGANIZATION, {
        url: this.organization.url,
        data: {
          datev_creditor: this.accountNumber
        }
      })
      this.hasAccountNumberChanged = false
      this.$store.commit(SET_SNACKBAR_MESSAGE, {
        message: 'Kundennummer erfolgreich aktualisiert',
        color: 'success'
      })
    },
    async saveShortName () {
      if (this.editShortName && this.editShortName.length > 13) {
        return
      }
      await this.$store.dispatch('organization/' + PATCH_ORGANIZATION, {
        url: this.organization.url,
        data: {
          short_name: this.editShortName
        }
      })
      this.shortNameChanged = false
      this.$store.commit(SET_SNACKBAR_MESSAGE, {
        message: 'Kurzname erfolgreich aktualisiert',
        color: 'success'
      })
    },
    async updateSaveFileUrl () {
      if (!this.isSuperuser) {
        return
      }
      await this.$store.dispatch('organization/' + UPDATE_LOCAL_ORGANIZATION_SETTING, {
        organization: this.organization,
        setting: {
          id: 'save_file_url',
          value: this.saveFileUrl
        }
      })
      this.hasSaveFileUrlChanged = false
      this.$store.commit(SET_SNACKBAR_MESSAGE, {
        message: 'URL zum Dateiaustausch erfolgreich aktualisiert',
        color: 'success'
      })
    },
    async saveIdentifiers () {
      const kro = this.editIdentifiers?.kro
      if (kro && kro.length !== 10) {
        return
      }
      if (this.reconciliationSettings.is_enabled && !this.reconciliationSettings.real_account && !kro) {
        this.$store.commit(SET_SNACKBAR_MESSAGE, {
          message: 'Entweder IBAN oder KRO muss bei aktivem Kollektenübertrag ausgefüllt sein.',
          color: 'error'
        })
        return
      }

      // Only include identifiers with actual values.
      // Sending null/undefined or empty strings for keys that don't exist in the backend
      // causes "OrganizationIdentifier matching query does not exist" (500).
      const cleanedIdentifiers = {}
      Object.keys(this.editIdentifiers).forEach(key => {
        const value = this.editIdentifiers[key]
        if (value) {
          cleanedIdentifiers[key] = value
        }
      })

      await this.$store.dispatch('organization/' + PATCH_ORGANIZATION, {
        url: this.organization.url,
        data: {
          identifiers: cleanedIdentifiers
        }
      })
      this.identifiersChanged = {}
      this.manuallyAddedIdentifierKeys = []
      this.$store.commit(SET_SNACKBAR_MESSAGE, {
        message: 'Identifikatoren erfolgreich aktualisiert',
        color: 'success'
      })
    },
    async onReconciliationEnabledChange () {
      if (!this.reconciliationSettings.is_enabled) {
        return
      }
      if (!this.reconciliationSettings.real_account && !this.editIdentifiers?.kro) {
        this.$store.commit(SET_SNACKBAR_MESSAGE, {
          message: 'Entweder IBAN oder KRO muss ausgefüllt sein, um den Kollektenübertrag zu aktivieren.',
          color: 'error'
        })
        await this.$nextTick()
        this.reconciliationSettings.is_enabled = false
        return
      }
      this.hasReconciliationSettingsChanged = true
      await this.saveReconciliationSettings()
    },
    async fixVirtualAccount () {
      this.reconciliationSettings.virtual_account = this.expectedVirtualAccount
      this.reconciliationSettings.is_enabled = true
      await this.saveReconciliationSettings()
    },
    electronicFormatIBAN (iban) {
      return formatIBAN(iban)
    },
    async fetchReconciliationSettings () {
      if (!this.organization || !this.organization.id) {
        return
      }
      // Capture the org this fetch is for so a stale, slow response can't clobber
      // settings for a different org the user has since navigated to.
      const orgId = this.organization.id
      try {
        const response = await this.$store.getters.restApi.get(`/organization/${orgId}/reconciliation_settings/`)
        if (this.organization?.id !== orgId) {
          return
        }
        this.reconciliationSettings = {
          ...response.data,
          is_enabled: !!response.data.reporting_mode && response.data.reporting_mode !== 'none'
        }
        this.hasReconciliationSettingsChanged = false
      } catch (e) {
        if (this.organization?.id !== orgId) {
          return
        }
        if (e.response?.status === 404) {
          this.reconciliationSettings = {
            is_enabled: false,
            real_account: '',
            virtual_account: '',
            reporting_mode: ''
          }
          this.hasReconciliationSettingsChanged = false
          return
        }
        // eslint-disable-next-line no-console
        console.error('Failed to fetch reconciliation settings', e)
      }
    },
    async saveReconciliationSettings () {
      if (this.reconciliationSettings.is_enabled && !this.reconciliationSettings.real_account && !this.editIdentifiers?.kro) {
        this.$store.commit(SET_SNACKBAR_MESSAGE, {
          message: 'Entweder IBAN oder KRO muss bei aktivem Kollektenübertrag ausgefüllt sein.',
          color: 'error'
        })
        return
      }
      if (!this.reconciliationSettings.is_enabled) {
        this.reconciliationSettings.reporting_mode = null
      } else if (!this.reconciliationSettings.reporting_mode) {
        this.reconciliationSettings.reporting_mode = 'pain_virtual_account'
      }
      try {
        const method = this.reconciliationSettings.id ? 'patch' : 'post'
        const url = this.reconciliationSettings.id
          ? `/organization/${this.organization.id}/reconciliation_settings/`
          : `/organization/${this.organization.id}/reconciliation_settings/`
        const response = await this.$store.getters.restApi[method](url, this.reconciliationSettings)
        this.reconciliationSettings = {
          ...response.data,
          is_enabled: !!response.data.reporting_mode && response.data.reporting_mode !== 'none'
        }
        this.hasReconciliationSettingsChanged = false
        this.$store.commit(SET_SNACKBAR_MESSAGE, {
          message: 'Kollektenübertrag-Einstellungen erfolgreich gespeichert.',
          color: 'success'
        })
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to save reconciliation settings', e)
        this.$store.commit(SET_SNACKBAR_MESSAGE, {
          message: 'Fehler beim Speichern der Kollektenübertrag-Einstellungen.',
          color: 'error'
        })
      }
    }
  },
  watch: {
    features: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (this.organization?.settings_local?.features?.require_pdata) {
          this.arePersonalDataRequiredForDonation = this.organization?.settings_local?.features?.require_pdata
          return
        }
        // eslint-disable-next-line camelcase
        this.arePersonalDataRequiredForDonation = newVal?.require_pdata || false
      },
    },
    contracts: {
      deep: true,
      async handler () {
        await this.loadBillingPlanAssociations()
      }
    },
    organization: {
      immediate: true,
      async handler (newVal, oldVal) {
        if (!newVal) {
          return
        }
        if (this.accountNumber !== newVal.datev_creditor && !this.hasAccountNumberChanged) {
          this.accountNumber = newVal.datev_creditor
        }
        if (this.editShortName !== newVal.short_name && !this.shortNameChanged) {
          this.editShortName = newVal.short_name
        }
        if (this.saveFileUrl !== newVal.settings_local?.features?.save_file_url && !this.hasSaveFileUrlChanged) {
          this.saveFileUrl = newVal.settings_local?.features?.save_file_url
        }

        // Reset reconciliation settings to a neutral state BEFORE touching editIdentifiers below.
        // editIdentifiers is watched (see 'editIdentifiers.kro'), and that watcher can fire before
        // fetchReconciliationSettings() for the new org resolves. Without this reset it would
        // otherwise compute against the PREVIOUS org's real_account/reporting_mode/id and could
        // save that stale data into the new org's reconciliation_settings.
        if (!oldVal || newVal.id !== oldVal.id) {
          this.reconciliationSettings = {
            is_enabled: false,
            real_account: '',
            virtual_account: '',
            reporting_mode: ''
          }
          this.hasReconciliationSettingsChanged = false
        }

        // Only update editIdentifiers if not currently changed or if we don't have them yet
        const currentIdentifiers = JSON.stringify(this.editIdentifiers)
        const newIdentifiers = JSON.stringify(newVal.identifiers || {})
        const areIdentifiersChangedByUIAnywhere = Object.values(this.identifiersChanged).some(v => v)

        if (currentIdentifiers !== newIdentifiers && !areIdentifiersChangedByUIAnywhere) {
          this.editIdentifiers = { ...(newVal.identifiers || {}) }
          this.manuallyAddedIdentifierKeys = []
          // Ensure all visible keys are in editIdentifiers so the text fields are reactive
          this.visibleIdentifierKeys.forEach(key => {
            if (this.editIdentifiers[key] === undefined) {
              this.$set(this.editIdentifiers, key, '')
            }
          })
        }

        if (this.contracts.length) {
          await this.loadBillingPlanAssociations()
        }
        // Only fetch reconciliation settings on initial load or if the organization id actually changed
        if (!oldVal || newVal.id !== oldVal.id) {
          await this.fetchReconciliationSettings()
        }
      }
    },
    'editIdentifiers.kro': {
      async handler (newKro) {
        const virtualAccount = calculateVirtualAccount(newKro)
        if (virtualAccount && virtualAccount !== this.reconciliationSettings.virtual_account) {
          this.reconciliationSettings.virtual_account = virtualAccount
          if (this.reconciliationSettings.is_enabled) {
            await this.saveReconciliationSettings()
          } else {
            this.hasReconciliationSettingsChanged = true
          }
        }
      }
    }
  },
  async mounted () {
    const promises = [
      this.$store.dispatch('staticConfiguration/' + FETCH_STATIC_CONFIGURATION),
      this.$store.dispatch('device/' + FETCH_GLOBAL_DEVICES),
      this.$store.dispatch('contracts/' + FETCH_CONTRACTS),
      this.$store.dispatch('payment/' + FETCH_DIRECT_PAYMENT_PAIN_FILES),
    ]
    if (this.isSuperuser) {
      promises.push(this.$store.dispatch('billing/' + FETCH_BILLING_PLANS))
    }

    await Promise.all(promises)
  }
}
</script>
<style lang="stylus">
#org-details
  .v-list-item__subtitle
    font-size: 1em
    line-height: 1.6
    color: black

  .v-list-item
    padding: 0

  .disable-events {
    pointer-events: none
  }

  .v-input--selection-controls {
    margin-top: 0 !important
  }

  .v-input__control {
    height: 36px
  }

.setting-row
  display: flex
  flex-direction: row

.setting-container
  max-width: fit-content
</style>
